import {DateAdapter, MAT_DATE_FORMATS} from "@angular/material/core";
import {CustomDateAdapter} from "../../adapters/custom-date.adapter";
import {CUSTOM_DATE_FORMAT} from "../formats/custom-date.format";

export const customDateProvider = [
  {
    provide: DateAdapter,
    useClass: CustomDateAdapter
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: CUSTOM_DATE_FORMAT
  }
];
